import { Color } from '@/types/theme';

export const neutral: Color = {
  100: '#F8F8F8',
  1000: '#171617',
  800: '#49484B',
  min: '#FFFFFF',
};

// TODO: Update colors 100, 300, 600, 700, 800, 900, 1000
export const primaries: Color = {
  100: '#F5F8FE',
  200: '#DDE7F8',
  300: '#B4CCF1',
  400: '#2966C6',
  500: '#1D488B',
  600: '#1A3F7A',
  700: '#122B54',
  800: '#122856',
  900: '#0D1C44',
  1000: '#081232',
};
